import React, { Component } from 'react';

class CountdownTimer extends Component {
    constructor(props) {
        super(props);

        this.targetDate = new Date(this.props.targetDate).getTime();

        this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };

        this.calculateTimeLeft = this.calculateTimeLeft.bind(this);
    }

    calculateTimeLeft() {
        const now = new Date().getTime();
        const timeLeft = this.targetDate - now;

        if (timeLeft > 0) {
            this.setState({
                days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
                hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((timeLeft % (1000 * 60)) / 1000),
            });
        } else {
            this.setState({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            });
        }
    }

    componentDidMount() {
        this.interval = setInterval(this.calculateTimeLeft, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            // 18d:05h:42m:30s
            <span>
                {String(this.state.days).padStart(2, '0')}d:
                {String(this.state.hours).padStart(2, '0')}h:
                {String(this.state.minutes).padStart(2, '0')}m:
                {String(this.state.seconds).padStart(2, '0')}s
            </span>
        );
    }
}

export default CountdownTimer;
